(() => {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function createParticle(hero, layer) {
    if (!hero.isConnected || reducedMotion.matches) return;
    if (layer.childElementCount >= 5) return;

    const particle = document.createElement('span');
    particle.className = 'sweet-particle';

    const useLeftSide = Math.random() < 0.5;

    // Keeps particles on the outer sides and away from the logo.
    const horizontalPosition = useLeftSide
      ? 5 + Math.random() * 28
      : 67 + Math.random() * 28;

    // Creates particles between approximately 4 and 8 pixels.
    const size = 6 + Math.random() * 4;

    // Each particle takes approximately 2.2–3.6 seconds to rise.
    const duration = 2600 + Math.random() * 1600;

    // Each particle rises through approximately 75–95% of the hero.
    const riseDistance =
      hero.clientHeight * (0.75 + Math.random() * 0.2);

    // Gives every particle a slightly different sideways movement.
    const sidewaysDrift = -30 + Math.random() * 60;

    particle.style.setProperty(
      '--particle-x',
      `${horizontalPosition}%`
    );

    particle.style.setProperty(
      '--particle-size',
      `${size}px`
    );

    particle.style.setProperty(
      '--particle-duration',
      `${duration}ms`
    );

    particle.style.setProperty(
      '--particle-rise',
      `${riseDistance}px`
    );

    particle.style.setProperty(
      '--particle-drift',
      `${sidewaysDrift}px`
    );

    layer.appendChild(particle);

    particle.addEventListener(
      'animationend',
      () => particle.remove(),
      { once: true }
    );
  }

  function initializeSweetBasicsParticles() {
    if (reducedMotion.matches) return;

    const hero = document.querySelector('#MainContent .banner');

    if (!hero || hero.dataset.sweetParticlesReady === 'true') {
      return;
    }

    hero.dataset.sweetParticlesReady = 'true';

    const layer = document.createElement('div');
    layer.className = 'sweet-particles-layer';
    layer.setAttribute('aria-hidden', 'true');
    hero.appendChild(layer);

    function scheduleParticle() {
      if (!hero.isConnected) return;

      // Creates particles at varied intervals.
      const delay = 500 + Math.random() * 550;

      window.setTimeout(() => {
        if (!document.hidden) {
          createParticle(hero, layer);

          // Occasionally creates another particle shortly afterward.
          if (Math.random() < 0.35) {
            window.setTimeout(
              () => createParticle(hero, layer),
              120 + Math.random() * 180
            );
          }
        }

        scheduleParticle();
      }, delay);
    }

    scheduleParticle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeSweetBasicsParticles
    );
  } else {
    initializeSweetBasicsParticles();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeSweetBasicsParticles
  );
})();